<template>
<div>
    <div class="title status1" >
        <span :class="status==14||status==15||status==16?'number_new':''"><span class="number">1</span><span>参加路考</span><span class="line"></span></span>
        <span :class="status==17?'number_new':''"><span class="number">2</span><span>现场签约</span><span class="line"></span></span>
        <span :class="status==18||status==19?'number_new':''"><span class="number">3</span><span>下载APP</span></span>
    </div>
</div>
</template>

<script>
export default {
  props: {
    status: String
  }
}
</script>
<style lang="scss" scoped>
.title{
    font-size: .24rem;
    width: 100%;
    margin-top: .56rem;
    color: #97989B;
    margin-bottom: .76rem;
    line-height: .36rem;
    white-space:nowrap;
    overflow: hidden;
    text-align:center;
    padding-bottom: .1rem;
}
.title span{
    display: inline-block;
}
.number{
    background: #97989B;
    width: .36rem;
    height: .36rem;
    border-radius: 50%;
    display: inline-block;
    line-height: .36rem;
    color: #fff;
    font-size: .24rem;
    text-align: center;
    margin-right: .1rem;
}
.number_new{
    color: #FF5548;
}
.number_new span:first-child{
    background: #FF5548
}
.line{
    width: .6rem;
    line-height: .18rem;
    height: .18rem;
    border-bottom: 1px solid #979797;
    text-align: center;
    margin: 0 0 .09rem 0;
}

</style>



// WEBPACK FOOTER //
// src/pages/pass-status/components/StatusBar.vue